import { faArrowLeftLong, faCoins } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import { ACADIMAC, ADDMONTH, baseURL } from "../../../API/API";
import Lodingsubmit from "../../Loding/Loding";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDataRefresh } from "../../../Pages/context/DataRefreshContext";
import useAuth from "../../../Pages/hooks/useAuth";
import "react-toastify/dist/ReactToastify.css";
import { faCalendarDays } from "@fortawesome/free-regular-svg-icons";

export default function AddMonth() {
  const axiosPrivate = useAxiosPrivate();
  const [Loding, setLoding] = useState(false);
  const Navigate = useNavigate();
  const { triggerRefresh } = useDataRefresh();
  const [Academacs, setAcademacs] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [selectedTeacherId, setSelectedTeacherId] = useState("");
  const { auth } = useAuth();
  let role = auth?.user?.role;
  if (!role || role === 'student') {
    if (auth?.user?.email === 'admin@academy.com' || auth?.user?.email === 'admin@example.com') {
      role = 'admin';
    } else if (auth?.user?.is_staff) {
      role = 'teacher';
    } else {
      role = 'student';
    }
  }
  const isAdmin = role === 'admin';

  const [data, setData] = useState({
    academicYear: "",
    chapterName: "",
    price: "",
    sortOrder: "",
    description: "",
  });
  const [image, setImage] = useState(null);

  function handleChange(e) {
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  async function handleSubmit(nav, save) {
    setLoding(true);

    try {
      const formData = new FormData();
      formData.append("academicYear", data.academicYear);
      formData.append("chapterName", data.chapterName);
      formData.append("price", data.price);
      formData.append("sortOrder", data.sortOrder);
      formData.append("description", data.description);
      formData.append("save", save ? "1" : "0");
      if (image) {
        formData.append("image", image);
      }
      if (isAdmin && selectedTeacherId) {
        formData.append("teacherId", selectedTeacherId);
      }

      await axiosPrivate.post(`${baseURL}/${ADDMONTH}/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("تم الحفظ بنجاح");

      setData({
        academicYear: "",
        chapterName: "",
        price: "",
        sortOrder: "",
        description: "",
      });
      setSelectedTeacherId("");
      setImage(null);

      triggerRefresh();
      if (nav) {
        Navigate("/DashboardLayout/content/months");
      }
    } catch (error) {
      console.error("حدث خطأ:", error);
      const errMsg = error.response?.data?.Message || error.response?.data?.message || "حدث خطأ أثناء الحفظ، حاول مرة أخرى لاحقاً";
      toast.error(errMsg);
    } finally {
      setLoding(false);
    }
  }

  useEffect(() => {
    async function fetchMonth() {
      try {
        const res = await axiosPrivate.get(`${baseURL}/${ACADIMAC}`);
        setAcademacs(res.data.data || []);
      } catch (error) {
        console.error("Error fetching academics:", error);
        setAcademacs([]);
      }
    }
    async function fetchTeachers() {
      try {
        const res = await axiosPrivate.get(`${baseURL}/learning/teachers`);
        setTeachers(res.data?.data || []);
      } catch (error) {
        console.error("Error fetching teachers:", error);
      }
    }

    fetchMonth();
    fetchTeachers();
  }, [axiosPrivate]);

  return (
    <>
      {Loding && <Lodingsubmit />}

      <div className="p-4 content" dir="rtl">
        <Link
          style={{ display: "block", textAlign: "end" }}
          to="/DashboardLayout/content/months"
        >
          <FontAwesomeIcon
            style={{ color: "var(--brand-200)" }}
            className="fw-bold fs-3 text-end"
            icon={faArrowLeftLong}
          />
        </Link>
        <h2 className="fw-bold">إضافة شهر دراسي</h2>
        <div className="d-flex align-items-center mb-5">
          <Form onSubmit={(e) => e.preventDefault()} className="Form w-75">
            <Form.Group className="mb-5" controlId="city">
              <Form.Label> المرحلة الدراسيه</Form.Label>
              <Form.Select
                required
                className="custom-select"
                name="academicYear"
                value={data.academicYear}
                onChange={handleChange}
              >
                <option value="">----</option>
                {Academacs.map((acd, index) => {
                  return (
                    <option key={index} value={acd.id}>
                      {acd.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>

            {isAdmin && (
              <Form.Group className="mb-5" controlId="teacherId">
                <Form.Label>المعلم (خاص بالمسؤول)</Form.Label>
                <Form.Select
                  className="custom-select"
                  name="teacherId"
                  value={selectedTeacherId}
                  onChange={(e) => setSelectedTeacherId(e.target.value)}
                >
                  <option value="">لا يوجد (الادمن الاساسي)</option>
                  {teachers.map((t, index) => (
                    <option key={index} value={t.id}>
                      {t.name} ({t.subject || "معلم"})
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            )}

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="text"
                name="chapterName"
                value={data.chapterName}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faCalendarDays} />
                <span className="textinpout">اسم الشهر</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="number"
                name="price"
                value={data.price}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faCoins} />
                <span className="textinpout">سعر الشهر</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="number"
                name="sortOrder"
                value={data.sortOrder}
                onChange={handleChange}
                placeholder=" "
                min={0}
                required
              />
              <Form.Label>
                <span className="textinpout">ترتيب الوحدة (كلما قل الرقم ظهر أولاً)</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                as="textarea"
                rows={3}
                className="inpoutFeald"
                name="description"
                value={data.description}
                onChange={handleChange}
                placeholder=" "
                style={{ height: "auto", paddingTop: "25px" }}
              />
              <Form.Label>
                <span className="textinpout">وصف الكورس / الشهر الدراسي (اختياري)</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="mb-5 text-end">
              <Form.Label className="small text-muted mb-2">صورة الكورس / الشهر (اختياري):</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e) => setImage(e.target.files[0])}
              />
            </Form.Group>

            <div className="d-flex gap-2">
              <Button
                onClick={() => handleSubmit(true, false)}
                style={{ padding: "0px 40px" }}
                className="custom-brand-btn-dhash"
              >
                إضافة
              </Button>

              <Button
                onClick={() => handleSubmit(false, false)}
                style={{
                  padding: "5px 40px",
                  backgroundColor: "var(--brand-100)",
                }}
                type="reset"
                className="custom-reset-btn"
              >
                حفظ وإضافة آخر
              </Button>

              <Button
                onClick={() => handleSubmit(true, true)}
                style={{
                  padding: "5px 40px",
                  backgroundColor: "transparent",
                  color: "black",
                }}
                className="custom-reset-btn"
              >
                حفظ كمسودة
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
}
